import * as React from 'react';

export const accordionFaqData = [
  {
    title: 'Почему так дорого?',
    description:
      <p>
        Курс Advance стоит дешевле, чем программы повышения квалификации в области обучения детей скорочтению.
        Если у вас несколько детей и каждый из них пойдёт на курсы или к репетитору, выйдет внушительная сумма. На
        нашем курсе вы получите знания, которые можно применить многократно. Учебные материалы останутся у вас
        после завершения курса. Цена курса складывается из времени и сил людей, которые трудились над его
        созданием. В общей сложности в курсе присутствует более 600 изображений; проделана большая методическая
        работа по сбору, структурированию, проверке материала для занятий; была написана книга и вручную созданы
        интерактивные упражнения. Мы знаем, что курс представляет собой большую образовательную ценность для
        родителей и детей.
      </p>
  },
  {
    title: 'Сколько времени займёт прохождение курса?',
    description:
      <>
        <p>Посмотреть видеоуроки и ознакомиться с дополнительными материалами можно за 4,5 часа. Но, чтобы осмыслить
          информацию, разобраться в ней, внимательно просмотреть материалы и перечитать тексты к урокам, понадобится
          больше времени — всё зависит от вашей личной скорости восприятия информации.</p>
        <p>Также нужно понимать, что для того, чтобы провести тестирования с детьми и начать применять всё или хотя
          бы часть упражнений, нужны время и немного терпения.</p>
        <p>На выполнение 1 из 15 уроков в тренажёре ребёнку нужно выделять примерно 40 минут (напомним, что в
          каждом уроке по 15 интерактивных упражнений).</p>
        <p>Чтобы прочитать одну главу из пособия и выполнить 6 заданий, нужно примерно 35 минут. Обратите
          внимание, что у всех детей разная скорость занятия, поэтому здесь мы указываем среднее число, то
          есть у вашего ребёнка эти цифры могут как уменьшиться, так и увеличиться.</p>
      </>
  },
  {
    title: 'Как быстро будет результат?',
    description:
      <p>Если вы будете заниматься с ребёнком, используя наши рекомендации каждый день, то через месяц скорость
        чтения увеличится в 1,5–2 раза, закрепится навык надёжного запоминания и умение концентрироваться,
        повысится скорость мышления.</p>
  },
  {
    title: 'А\u00A0я\u00A0справлюсь, если я\u00A0не\u00A0педагог?',
    description:
      <p>В наших обучающих роликах мы даём подробные рекомендации именно для родителей без педагогического
        образования. Во время курса преподаватели ответят на любой вопрос, возникающий входе занятий с ребёнком.</p>
  },
];
